<!-- 大屏轮播demo 2021-4-28 lxx -->
<template>
    <div class="carouselDemo">
        <el-carousel height="100vh" direction="vertical" :interval="60000" arrow="never" indicator-position="none" style="pointer-events:none;" >
            <el-carousel-item v-for="item in imagesbox" :key="item.id">
                <img :src="item.idView" class="image">
            </el-carousel-item>
            <!-- <el-carousel-item>
                <div class="image">
                    <h1 style="text-align:center">赛象科技</h1>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="image">
                    <h1 style="text-align:center">欢迎您！</h1>
                </div>
            </el-carousel-item> -->
        </el-carousel>
    </div>
    <!--vue原生写-->
    <!-- <div class="slide-wrap">        
        <ul class="slide-bar" :style="ulWidth" :class="{'tran': noLast}">            
            <li v-for="item in list" style="width:100%">
                <img :src="item"> 
            </li>        
        </ul>         -->
        <!-- <div class="arrow">            
            <img :src="arrow_left" class="arrow_left" @click="prev">            
            <img :src="arrow_right" class="arrow_right" @click="next">        
        </div>         -->
        <!-- <div class="pagnator">            
            <span v-for="(page, index) in list" :class="{'active': index == current + 1,'extra': index == 0 || index == list.length -1}"></span>        
        </div>     -->
    <!-- </div>    -->

</template>
<script>
export default {
    name:'demo',
    data () {
        return {
            imagesbox:[
                {id:0,idView:require("../../assets/img/demotv/picone.jpg")},
                {id:1,idView:require("../../assets/img/demotv/pictwo.jpg")},
                {id:2,idView:require("../../assets/img/demotv/picthree.jpg")},
                {id:3,idView:require("../../assets/img/demotv/picfour.jpg")},
                {id:4,idView:require("../../assets/img/demotv/picfive.jpg")}
            ],
            // list: [ //数组前后各增加一张图片     
            //     require('../../assets/img/info.png'),    
            //     require('../../assets/img/info.png'),                      
            //     require('../../assets/img/demotv/pink.png'),                
            //     require('../../assets/img/demotv/purple.png'),                
            //     require('../../assets/img/answer.png'),   
            //     require('../../assets/img/info.png'),                      
            // ],                       
            // bar: {                
            //     width: '0',                
            //     transform: 'translateX(0)',            
            // },            
            // current: 0,            
            // noLast: true
        }
    },
    // computed: {            
    //     ulWidth(){                                
    //         this.bar = {                    
    //             transform: 'translateX(-'+ ((this.current+1) * 100) +'%)',                
    //          }                
    //          return this.bar;            
    //     }           
    //  },    
    //  methods: {             
    //      next(){            
    //         this.current ++;                       
    //         if (this.current == this.list.length-2) {                 
    //             setTimeout(() => {                    
    //                 this.noLast = false;                    
    //                 this.current = 0;                
    //              }, 500);            
    //         }            
    //         this.noLast = true;        
    //      },               
    //       autoSwitch(){ //自动播放            
    //         this.timer = setInterval(() =>{                
    //             this.next();            
    //         },3000)        
    //       }    
    // },    
    // created(){      
    //     this.autoSwitch();    
    // }
}
</script>
<style scoped>
/* .slide-box {    
    width: 300px;    
    margin: auto;
}
.slide-wrap {    
    overflow: hidden;    
    position: relative;
}
.slide-bar {    
    display: -webkit-box;
}
.tran {    
    transition: all 0.5s;
}
.slide-bar li {    
    height: 100%;
}
.slide-bar img {     
    width: 100%;    
    height: 100vh;
} */
/* .arrow img {    
    position: absolute;    
    top: 46%;    
    transform: translateY(-50%);    
    padding: 6px 0;    
    cursor: pointer;
} */
/* .arrow .arrow_left {    
    left: 0;
}
.arrow .arrow_right {    
    right: 0;
} */
/* .pagnator {    
    position: absolute;    
    bottom: 10px;    
    left: 0;    
    right: 0;
}
.pagnator span {    
    display: inline-block;       
    width: 10px;    
    height: 10px;    
    margin: 2px;    
    border-radius: 50%;    
    background: rgba(255, 255, 255, 0.5);    
    cursor: pointer;
}
.active {    
    background: rgba(76, 175, 80, 0.64) !important;
}
.extra {    
    display: none !important;
} */
.carouselDemo{
    width: 100%;
    height: 100%;
}
.image{
    width: 100%;
    height: 100vh;
}
</style>